export const ID_VERIFICATION_POLLING_INTERVAL = 4000;
export const ID_VERIFICATION_LIVE_STATUSES = ['initialized', 'in_progress'];
export const isIdVerificationLiveStatus = (status?: string) =>
  !!status && ID_VERIFICATION_LIVE_STATUSES.includes(status);
